export default "__VITE_ASSET__a253c0f4__"